module.exports = __webpack_public_path__ + "assets/img/bg.30e068ea.png";